var React = require('react');

function DownloadInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11 0.000976562L11 21.001","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M0.5 26.501H21.5","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M19 13.001L11 21.501L3 13.001","strokeWidth":"2","key":2})]);
}

DownloadInline.defaultProps = {"width":"22","height":"28","viewBox":"0 0 22 28","fill":"none"};

module.exports = DownloadInline;

DownloadInline.default = DownloadInline;
